export default {"src":"/_next/static/media/form-success.c4d080f3.svg","height":425,"width":658};